import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import numeral from 'numeral'
import axios from 'axios'

import Icon from 'Pods/Shared/Icon/Icon'
import InputFieldWithPrefix from 'Pods/Shared/InputFieldWithPrefix'
import TextareaField from 'Pods/Shared/TextareaField'

class CounterOfferModal extends React.Component {
  constructor() {
    super()

    this.state = this.getInitialState()

    this.onModalClose = this.onModalClose.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
    this.sendCounterOffer = this.sendCounterOffer.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.onFetchOfferSuccess = this.onFetchOfferSuccess.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  getInitialState() {
    return {
      offerId: null,
      status: null,
      previousComment: null,
      offerPrice: 0,
      previousOfferPrice: 0,
      designerRoyaltyRate: 96,
      error: null,
      inputErrorClass: '',
      disableSubmit: false,
      comment: '',
    }
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()
    this.fetchData(this.props.applicationId)
  }

  componentWillUnmount() {
    this.cancelSource.cancel()
  }

  fetchData(applicationId) {
    axios.get(`/api/internal/job-applications/${applicationId}/offer`, { cancelToken: this.cancelSource.token })
      .then(this.onFetchOfferSuccess)
      .catch((error) => {})
  }

  onFetchOfferSuccess(response) {
    this.setState({
      offerId: response.data.data.id,
      status: response.data.data.attributes.status,
      previousComment: response.data.data.attributes.comment,
      previousOfferPrice: response.data.data.attributes.price,
      designerRoyaltyRate: response.data.data.attributes.designerRoyaltyRate,
    })
  }

  onOfferPriceInput(e) {
    const inputErrorClass = this.inputClass(numeral(e.target.value).value())

    this.setState({
      offerPrice: e.target.value,
      error: null,
      inputErrorClass,
      active: inputErrorClass === '',
      revenue: e.target.value * this.state.designerRoyaltyRate / 100,
    })

    this.showError(numeral(e.target.value).value())
  }

  inputClass(offerPrice) {
    if (offerPrice < this.state.previousOfferPrice * 0.5) {
      return 'is-invalid'
    }
    return ''
  }

  showError(offerPrice) {
    let message

    if (!offerPrice) {
      message = 'Price offer cannot be blank'
    } else if (offerPrice < this.state.previousOfferPrice * 0.5) {
      message = 'Price offer cannot be less than 50% of initial offer'
    }

    this.setState({ error: message })
  }

  onModalClose(e) {
    this.setState(this.getInitialState())
    this.props.closeModal(e)
  }

  handleFormSubmit(e) {
    e.preventDefault()
    this.showError(this.state.offerPrice)

    if (this.state.error) {
      return null
    }
    this.sendCounterOffer()
  }

  handleInputChange(e) {
    this.setState({ comment: e.target.value })
  }

  sendCounterOffer() {
    this.setState({ disableSubmit: true })

    axios.put(`/api/internal/jobs/${this.props.id}/counter-offer`, {
      data: {
        attributes: {
          applicationId: this.props.applicationId,
          offerPrice: this.state.offerPrice,
          comment: this.state.comment,
        },
      },
    })
      .then(this.onSubmitSuccess)
      .catch(this.onSubmitFailure)
  }

  onSubmitSuccess() {
    this.setState({ disableSubmit: false })
    App.events.publish('app:notification:flash:success', 'Your offer has been sent successfully')
    this.onModalClose()
    setTimeout(() => window.location.reload(), 3000)
  }

  onSubmitFailure() {
    this.setState({ disableSubmit: false })
    App.events.publish('app:notification:flash:error', 'Something went wrong, please try again')
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={this.onModalClose}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal" onClick={(e) => e.stopPropagation()}>
          <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.onModalClose}>
            <Icon type={['fal', 'times']} color="grey-dark" />
          </button>
          <div className="overlay-modal--content overlay-modal--jobs">
            <div className="l-inner-large">
              <h2 className="modal-title">Counter offer</h2>
              <div className="previous-offer">
                <h3 className="modal-title--small">
                  {this.state.status === 'seller_offer' ? 'Designer\'s offer' : 'Client\'s offer'}
                </h3>
                <p className="modal-description">{this.state.previousComment}</p>

                <h3 className="modal-title--small">Pricing</h3>
                <span className="previous-offer__pricing">
                  Offer <strong>${this.state.previousOfferPrice}</strong>
                </span>
                {this.state.status === 'buyer_offer' && (
                <span className="previous-offer__pricing">
                  Revenue <strong>${this.state.previousOfferPrice * this.state.designerRoyaltyRate / 100}</strong>
                </span>
                )}
              </div>
              <form onSubmit={(e) => this.handleFormSubmit(e)}>
                <h3 className="modal-title--small">Your counter offer</h3>

                <div className="row">
                  <div className="col-6 col-md-4">
                    <InputFieldWithPrefix
                      id="item-price-offer"
                      name="item_price_offer[price]"
                      type="number"
                      prefix="$"
                      required
                      value={this.state.offerPrice}
                      formClassName="form-group-grey"
                      inputClassName="form-control-grey"
                      onChange={(e) => this.onOfferPriceInput(e)}
                      showError={this.state.error && this.state.error.length > 0}
                      errorText={this.state.error}
                    />
                  </div>

                  {this.state.status === 'buyer_offer' && this.state.revenue && (
                    <div className="col-6 col-md-3 counter-offer-revenue">
                      <p className="modal-description">Revenue</p>
                      <strong>${this.state.revenue}</strong>
                    </div>
                  )}
                </div>

                <h3 className="modal-title--small">Write a comment</h3>
                <TextareaField
                  id="item-price-offer-comment"
                  name="item_price_offer[comment]"
                  value={this.state.comment}
                  formClassName="form-group-grey"
                  inputClassName="form-control-grey"
                  onChange={this.handleInputChange}
                />
                <div className="footer u-text-right u-mt10">
                  <button className="btn btn-fat btn-outline-default" onClick={this.onModalClose}>Cancel</button>
                  <button type="submit" className="btn btn-fat btn-primary u-ml10" disabled={this.state.disableSubmit}>
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

CounterOfferModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  applicationId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  id: PropTypes.string.isRequired,
  modalIsOpen: PropTypes.bool,
}

CounterOfferModal.defaultProps = {
  modalIsOpen: false,
}

export default CounterOfferModal
